
    import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
    import { faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import C1Tag from '@/C1Components/C1Tag.vue';

    export default {
        name: 'C1OccupationSelector',

        components: {
            C1Tag,
            FontAwesomeIcon,
        },

        props: {
            value: {
                type: null,
                default() {
                    return [];
                },
            },
            selectedItem: {
                type: Object,
                default() {
                    return {};
                },
            },
            searchResults: {
                type: Array,
                required: false,
                default() {
                    return [];
                },
            },
            jobCategories: {
                type: Array,
                required: false,
                default() {
                    return [];
                },
            },
            filterBy: {
                type: String,
                default: 'index',
            },
            label: {
                type: String,
                default: 'label',
            },
            subLabel: {
                type: String,
                default: 'label2',
            },
            loading: {
                type: Boolean,
                default: false,
            },
            isSingleSelect: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: 'Select occupation',
            },
            placeholderFocus: {
                type: String,
                default: 'Select occupation',
            },
            isInvalid: {
                type: Boolean,
                default: false,
            },
            noMobileMode: {
                type: Boolean,
                default: false,
            },
        },

        $_veeValidate: {
            // fetch the current value from the innerValue defined in the component data.
            value() {
                return this.searchData.occupations ? this.searchData.occupations : null;
            },
        },

        data() {
            return {
                searchData: {
                    search: '',
                    occupations: [],
                },
                filteredResults: [],
                placeholderLabel: '',
                isSearchOpen: false,
                isLoading: false,
                isFullScreenDisplay: false,
                currentDisplay: null,
                pointer: -1,
                isCategoryOpen: false,
                filteredCategories: [],
                currentCategory: null,
                faIcons: {
                    falTimes,
                    farChevronDown,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'c1-occupation-search',
                    this.getFullScreenClass,
                    this.getSearchOpenClass,
                    this.getIsInvalidClass,
                ];
            },

            getFullScreenClass() {
                return this.isFullScreenDisplay ? 'c1-occupation-search--fullscreen' : '';
            },

            getSearchOpenClass() {
                return (this.isSearchOpen && this.searchData.search.length) || this.isCategoryOpen ? 'c1-occupation-search--open' : '';
            },

            getIsInvalidClass() {
                return this.isInvalid ? 'is-invalid' : '';
            },

            getSearchQuery() {
                return this.searchData.search.substring(0, 3);
            },

            getTopResults() {
                return this.filteredResults;
            },
        },

        watch: {
            value: {
                // eslint-disable-next-line
                handler: function(value) {
                    if (value) {
                        this.searchData = JSON.parse(JSON.stringify(value));
                    }
                    this.onValueChange();
                },
                deep: true,
            },
            selectedItem: {
                // eslint-disable-next-line
                handler: function(newItem) {
                    if (newItem.id) {
                        this.searchData.occupations.push(newItem);
                        this.$emit('input', this.searchData);
                    }
                },
                deep: true,
            },
            searchResults: {
                // eslint-disable-next-line
                handler: function() {
                    this.filterResults();
                },
            },

            loading(value) {
                if (!value) {
                    this.filterResults();
                }
            },
        },

        created() {
            this.filteredCategories = JSON.parse(JSON.stringify(this.jobCategories));
            if (this.value) {
                this.searchData = JSON.parse(JSON.stringify(this.value));
                this.loadPreselected();
            }
            this.onValueChange();
            this.isSearchOpen = false;

            this.placeholderLabel = this.placeholder;
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },

        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        },

        methods: {
            onValueChange() {
                if (this.value) {
                    if (this.isSingleSelect && this.searchData.occupations.length) {
                        this.searchData.search = this.searchData.occupations[0].name;
                        if (this.searchData.occupations.length > 1) {
                            throw new TypeError('Number of selected occupation incorrect for single select!');
                        }
                    } else {
                        const previousSearchtext = this.searchData.search;
                        this.searchData.search = JSON.parse(JSON.stringify(this.value.search));
                        if (this.searchData.search.length && previousSearchtext !== this.searchData.search) {
                            this.$emit('search-change', this.getSearchQuery);
                        }
                    }
                }
            },

            changePlaceholder(isfocus) {
                if (this.isMobile() && !this.noMobileMode) {
                    this.isFullScreenDisplay = true;
                    window.scrollTo(0, 1);
                }
                if (!isfocus) {
                    this.placeholderLabel = this.placeholder;
                } else {
                    this.placeholderLabel = this.placeholderFocus;
                    if (this.searchData.search.length > 0) {
                        this.doSearch(this.searchData.search);
                    }
                }
            },

            loadPreselected() {
                if (typeof this.searchData.occupations !== 'undefined') {
                    const preselectedOccupations = this.searchData.occupations;
                    if (preselectedOccupations.length) {
                        this.filteredCategories.forEach((jobCategory) => {
                            const categoryIndex = preselectedOccupations.findIndex(
                                item => item.category_id === jobCategory.id,
                            );
                            if (categoryIndex !== -1) {
                                this.$set(jobCategory, 'is_open', true);
                                jobCategory.occupations.forEach((jobOccupation) => {
                                    const occupationIndex = preselectedOccupations.findIndex(
                                        occupationItem =>
                                            occupationItem.id === jobOccupation.id,
                                    );
                                    if (occupationIndex !== -1) {
                                        this.$set(jobOccupation, 'is_selected', true);
                                    } else {
                                        this.$set(jobOccupation, 'is_selected', false);
                                    }
                                });
                            }
                        });
                    }
                }
            },

            doSearch(value) {
                if (this.isSingleSelect && this.searchData.search !== value) {
                    this.clearOccupations();
                }
                if (value.length < 3) {
                    this.clearFilterResults();
                    this.isCategoryOpen = false;
                } else {
                    if (this.searchData.search.substring(0, 3) !== value.substring(0, 3)) {
                        this.$emit('search-change', value.substring(0, 3));
                    }
                    this.$nextTick(() => {
                        this.filterResults();
                        this.isSearchOpen = true;
                        this.isCategoryOpen = false;
                    });
                }
                if (value.length === 0) {
                    this.isCategoryOpen = true;
                }
                this.searchData.search = value;
            },

            filterResults() {
                if (this.searchResults.length > 0) {
                    const searchKeyword = this.searchData.search.toLowerCase().split();
                    this.filteredResults = this.searchResults.filter((item) => {
                        const filterByKey = this.filterBy ? item[this.filterBy] : item;
                        return filterByKey.toLowerCase().includes(searchKeyword);
                    });
                }
            },

            selectResult(result, index) {
                this.pointer = index;
                this.searchData.search = '';
                if (result.category_id) {
                    const categoryIndex = this.filteredCategories.findIndex(
                        item => item.id === result.category_id,
                    );
                    const jobCategory = this.filteredCategories[categoryIndex];
                    this.selectCategory(jobCategory);

                    if (result.occupation_id) {
                        const occupationIndex = jobCategory.occupations.findIndex(
                            item => item.id === result.occupation_id,
                        );
                        const jobOccupation = jobCategory.occupations[occupationIndex];
                        if (!jobOccupation.is_selected) {
                            if (this.isSingleSelect) {
                                this.clearOccupations();
                                this.searchData.search = jobOccupation.name;
                                this.isCategoryOpen = false;
                                this.closeFullScreen();
                            }
                            this.$set(jobOccupation, 'is_selected', true);
                            this.searchData.occupations.push({
                                id: jobOccupation.id,
                                category_id: jobCategory.id,
                                name: jobOccupation.name,
                                slug: jobOccupation.slug,
                            });
                        }
                    }
                }
                this.$emit('input', this.searchData);
                this.isSearchOpen = false;
            },

            selectCategory(jobCategory) {
                this.currentCategory = jobCategory.id;
                if (!jobCategory.is_open) {
                    this.$set(jobCategory, 'is_open', true);
                } else {
                    this.$set(jobCategory, 'is_open', false);
                }
            },

            selectOccupation(jobCategory, jobOccupation) {
                this.$set(jobOccupation, 'is_selected', !jobOccupation.is_selected);
                if (jobOccupation.is_selected) {
                    if (this.isSingleSelect) {
                        this.clearOccupations();
                        this.searchData.search = jobOccupation.name;
                        this.closeFullScreen();
                    }
                    this.searchData.occupations.push({
                        id: jobOccupation.id,
                        category_id: jobCategory.id,
                        name: jobOccupation.name,
                        slug: jobOccupation.slug,
                    });
                    this.isCategoryOpen = false;
                } else {
                    this.removeOccupation(jobOccupation);
                }
                this.$emit('input', this.searchData);
            },

            removeOccupation(occupation) {
                this.$set(occupation, 'is_selected', false);
                const occupationIndex = this.searchData.occupations.findIndex(
                    item => item.id === occupation.id,
                );
                this.searchData.occupations.splice(occupationIndex, 1);
                if (occupation.category_id) {
                    const categoryIndex = this.filteredCategories.findIndex(
                        item => item.id === occupation.category_id,
                    );
                    const jobCategory = this.filteredCategories[categoryIndex];
                    if (occupation.id) {
                        const occupationIndex = jobCategory.occupations.findIndex(
                            item => item.id === occupation.id,
                        );
                        const jobOccupation = jobCategory.occupations[occupationIndex];
                        this.$set(jobOccupation, 'is_selected', false);
                    }
                }
                this.$emit('input', this.searchData);
            },

            clearSearch() {
                this.searchData.search = '';
                this.clearFilterResults();
                if (this.isSingleSelect) {
                    this.clearOccupations();
                    this.isCategoryOpen = false;
                }
            },

            clearFilterResults() {
                this.filteredResults = [];
                this.resetPointer();
                this.$emit('search-change', '');
                this.$emit('input', this.searchData);
            },

            clearOccupations() {
                this.searchData.occupations = [];
                this.isCategoryOpen = false;
                this.filteredCategories = JSON.parse(JSON.stringify(this.jobCategories));
            },

            getLabel(result) {
                const customLabel = this.label ? result[this.label] : result;
                return customLabel;
            },

            getSubLabel(result) {
                let customSubLabel = '';
                if (result) {
                    customSubLabel = this.subLabel ? result[this.subLabel] : result;
                } else {
                    customSubLabel = 'in all categories';
                }
                return customSubLabel;
            },

            optionHighlight(index) {
                return {
                    'c1-occupation-search-results__item--selected': index === this.pointer,
                };
            },

            onEnterKeyDown() {
                if (this.pointer > -1) {
                    const selectedResult = this.getTopResults[this.pointer];
                    this.selectResult(selectedResult, this.pointer);
                }
            },

            onArrowKeyDown() {
                if (this.pointer < this.getTopResults.length - 1) {
                    this.pointer = this.pointer + 1;
                    this.$refs.search_results.scrollBy(0, 53);
                }
            },

            onArrowKeyUp() {
                if (this.pointer > 0) {
                    this.pointer = this.pointer - 1;
                    this.$refs.search_results.scrollBy(0, -53);
                }
            },

            resetPointer() {
                this.pointer = 0;
                this.$refs.search_results.scrollTo(0, 0);
            },

            closeResults() {
                this.isSearchOpen = false;
                this.isCategoryOpen = false;
            },

            handleClickOutside(e) {
                if (!this.$el.contains(e.target)) {
                    this.closeResults();
                }
            },

            toggleCategory() {
                if (this.isMobile() && !this.isFullScreenDisplay && !this.noMobileMode) {
                    this.isFullScreenDisplay = true;
                    window.scrollTo(0, 1);
                }
                this.currentDisplay = 'category';
                this.isCategoryOpen = !this.isCategoryOpen && (this.searchData.search.length === 0);
            },

            toggleJobCategory(jobCategory) {
                this.$set(jobCategory, 'is_open', false);
            },

            isMobile() {
                return window.matchMedia('(max-width: 767px)').matches;
            },

            closeFullScreen() {
                this.isCategoryOpen = false;
                this.isSearchOpen = false;
                this.isFullScreenDisplay = false;
            },
        },

    };
